import { render, staticRenderFns } from "./FileHistoryModal.vue?vue&type=template&id=98690178"
import script from "./FileHistoryModal.vue?vue&type=script&lang=js"
export * from "./FileHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports